/* eslint-disable indent */
import { entityStore } from '~/utility/BinSentry-ui-utility';
import { html, LitEntity, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';
import './import-mapping-selector';
import './import-mapping-view';

class ImportMapping extends LitEntity {
  static get properties() {
    return {
      availableHeaders: { type: Array },
      recordPreview: { type: Object },
      targetGroupGenerator: { type: Function },
      importPreviewRenderer: { type: Function },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (['mapping-assigned', 'validating'].includes(this.entity.properties.state)) {
      return html`
        <bn-surface>
          <bn-loading><p>Validating Mapping...</p></bn-loading>
        </bn-surface>`;
    }

    return html`
      ${renderIf(this.beginMappingAction, () => html`
        <import-mapping-selector
          .href="${this.beginMappingAction.href}"
          .availableHeaders="${this.availableHeaders}"
          .recordPreview="${this.recordPreview}"
          .targetGroupGenerator="${this.targetGroupGenerator}"
          .importPreviewRenderer="${this.importPreviewRenderer}"
          @mapping-created="${this._onMappingCreated}"
        ></import-mapping-selector>
      `)}

      ${renderIf(!this.beginMappingAction && this.assignedMappingHref, () => html`
        <import-mapping-view
          .href="${this.assignedMappingHref}"
          .availableHeaders="${this.availableHeaders}"
          .recordPreview="${this.recordPreview}"
          .targetGroupGenerator="${this.targetGroupGenerator}"
          .importPreviewRenderer="${this.importPreviewRenderer}"
        ></import-mapping-view>
      `)}
    `;
  }

  async _onMappingCreated() {
    await entityStore.fetchWait(this.href);
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    this.assignedMappingHref = this.getHref('https://api.binsentry.com/rel/import-mapping');
    this.beginMappingAction = this.entity.getAction('begin-mapping');
    this.beginMappingAction && await entityStore.fetchWait(this.beginMappingAction.href); // this makes sure mapping selector is updated
  }
}

window.customElements.define('import-mapping', ImportMapping);
